import get from 'lodash/get';
import React from 'react';
import Dropzone from 'react-dropzone';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';
import Icon from '../Icon';
import ImageLoader from '../ImageLoader';

type PropType = {
    className?: string;
    name: string;
    label?: string;
    placeholder?: string;
    value?: any;
    withError?: boolean;
    disabled?: boolean;
    setFieldValue: Function;
    setTouched: Function;
    onFocus: Function;
    onBlur: Function;
};

type StateType = { accepted: any; rejected: boolean };

class Upload extends React.Component<PropType, StateType> {
    getBase64 = (file: File) => {
        const reader = new FileReader();
        return new Promise((resolve: any, reject: any) => {
            reader.readAsDataURL(file);
            reader.onload = function () {
                const [start, shorten] = String(reader.result).split(',');
                resolve(shorten);
            };
            reader.onerror = function (error) {
                reject('Error: ', error);
            };
        });
    };

    handleChange = (value: string) => {
        const { name, setFieldValue, setTouched } = this.props;

        setFieldValue(name, value);
        setTouched({ [name]: true });
    };

    handleNewFile = (files: any) => {
        const { placeholder, value } = this.props;
        const text = placeholder ? I18n.l(placeholder) : <span />;
        const alert = I18n.l('form.upload.alert');
        const fileRejected = I18n.l('form.upload.fileRejected');

        if (files.isDragReject || (files.rejectedFiles.length && files.rejectedFiles.length > 0)) {
            return (
                <React.Fragment>
                    <IconWrapper>
                        <Icon name="times" />
                    </IconWrapper>
                    <Text>{fileRejected}</Text>
                </React.Fragment>
            );
        }

        if (files.acceptedFiles.length) {
            // TODO: prepare for multiple
            const file = files.acceptedFiles[0];
            this.getBase64(file)
                .then((base64File: any) => {
                    this.handleChange(base64File);
                })
                .catch(console.warn);
            return (
                <React.Fragment>
                    <PreviewWrapper>
                        <ImageLoader src={file.preview} />
                    </PreviewWrapper>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {!value && (
                    <React.Fragment>
                        <IconWrapper>
                            <Icon name="file-upload" />
                        </IconWrapper>
                        <Text>{text}</Text>
                        <Alert>{alert}</Alert>
                    </React.Fragment>
                )}
                {!!value && (
                    <React.Fragment>
                        <PreviewWrapper>
                            <ImageLoader src={value} />
                        </PreviewWrapper>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    };

    render() {
        return (
            <AppContext.Consumer>
                {({ theme }) => (
                    <Wrapper theme={theme}>
                        <Dropzone accept="image/*">{this.handleNewFile}</Dropzone>
                    </Wrapper>
                )}
            </AppContext.Consumer>
        );
    }
}

const Wrapper = styled.div`
  width: 100%;

  > div {
    ${({ theme }) => get(theme, 'form.upload')};

    &:hover {
      opacity: 0.8;
    }
  }
`;

const IconWrapper = styled.p`
  display: inline-block;
  color: #999;
  font-size: 42px;
  margin-bottom: 20px;
  width: 100%;
`;

const Text = styled.p`
  display: inline-block;
  line-height: 1.5;
  width: 75%;
`;

const Alert = styled.p`
  display: inline-block;
  font-weight: 900;
  width: 100%;
`;

const PreviewWrapper = styled.div`
  display: block;
  height: 200px;
  width: 100%;
  overflow: hidden;

  .image-loader-item {
    display: inline-block;
    height: 200px;
    max-width: 100%;
  }
`;

export default Upload;
